import { useEffect, useState } from "react";
import CrudPage from "@/components/CrudPage";
import { api } from "@/lib/api";

export default function DIDs() {
  const [ops, setOps] = useState([]);
  const [ipbxs, setIpbxs] = useState([]);
  const [anuncios, setAnuncios] = useState([]);

  useEffect(() => {
    Promise.all([api.get("/operadoras"), api.get("/ipbxs"), api.get("/anuncios")])
      .then(([o, i, a]) => { setOps(o.data); setIpbxs(i.data); setAnuncios(a.data); })
      .catch(() => { setOps([]); setIpbxs([]); setAnuncios([]); });
  }, []);

  const opMap = Object.fromEntries(ops.map(o => [o.id, o.nome]));
  const ipbxMap = Object.fromEntries(ipbxs.map(i => [i.id, i.nome]));
  const anuncioMap = Object.fromEntries(anuncios.map(a => [a.id, a.nome]));

  const destino = (r) => {
    if (r.ipbx_id) return <span>{ipbxMap[r.ipbx_id] || "IPBX"}</span>;
    if (r.anuncio_id) return <span>Anúncio: {anuncioMap[r.anuncio_id] || "-"}</span>;
    return <span className="text-[color:var(--text-muted)]">sem destino</span>;
  };

  return (
    <CrudPage
      title="DIDs"
      subtitle="Números autorizados e destino de entrada"
      endpoint="/dids"
      testidPrefix="dids"
      headers={["Número E.164", "Prefixo recebido", "Operadora", "Destino", "Gravação", "Descrição", "Status"]}
      renderRow={(r) => (
        <>
          <td className="font-mono font-medium">{r.numero}</td>
          <td className="font-mono">{r.prefixo_recebido || <span className="text-[color:var(--text-muted)]">-</span>}</td>
          <td>{opMap[r.operadora_id] || <span className="text-[color:var(--text-muted)]">-</span>}</td>
          <td>{destino(r)}</td>
          <td>{r.recording_enabled ? <span className="sbc-tag tag-online">gravar</span> : <span className="text-[color:var(--text-muted)]">não</span>}</td>
          <td className="text-[color:var(--text-secondary)]">{r.descricao || "-"}</td>
          <td>{r.enabled ? <span className="sbc-tag tag-online">ativo</span> : <span className="sbc-tag tag-offline">inativo</span>}</td>
        </>
      )}
      defaultValues={{ numero: "", prefixo_recebido: "", operadora_id: "", ipbx_id: "", anuncio_id: "", descricao: "", recording_enabled: false, enabled: true }}
      fields={[
        { key: "numero", label: "Número DID E.164", mono: true, placeholder: "+557135999160", full: true },
        { key: "prefixo_recebido", label: "Prefixo recebido da operadora", mono: true, placeholder: "Ex: 102525", hint: "Use quando a operadora envia o DID com prefixo antes do numero. Para mais de um, separe por virgula." },
        { key: "operadora_id", label: "Operadora", type: "select", options: [
          { value: "", label: "-- selecione --" }, ...ops.map(o => ({ value: o.id, label: o.nome }))
        ]},
        { key: "ipbx_id", label: "Enviar direto para IPBX", type: "select", options: [
          { value: "", label: "Sem IPBX direto" }, ...ipbxs.map(i => ({ value: i.id, label: i.nome }))
        ], hint: "Se selecionar IPBX, ele tem prioridade sobre o anúncio." },
        { key: "anuncio_id", label: "Se não houver IPBX, tocar anúncio", type: "select", options: [
          { value: "", label: "Sem anúncio" }, ...anuncios.map(a => ({ value: a.id, label: a.nome }))
        ]},
        { key: "descricao", label: "Descrição", placeholder: "Ex: Número principal Salvador", full: true },
        { key: "recording_enabled", label: "Gravar chamadas deste DID", type: "toggle", hint: "A gravação será enviada ao armazenamento externo configurado." },
        { key: "enabled", label: "Ativo", type: "toggle" },
      ]}
    />
  );
}
